<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">General</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <pdq-input
        [formControl]="formGroup.get('internalName')"
        label="Internal Name*"
        placeholder="Smart Cart"
        [invalid]="formGroup.get('internalName')?.errors?.required"
        invalidMsg="Internal name is required"></pdq-input>
      <pdq-input
        [formControl]="formGroup.get('internalDescription')"
        label="Internal Description"
        placeholder="Enter description"></pdq-input>
    </div>
  </div>
</pdq-card>

@for (section of sections; track section.id) {
  <div class="section">
    <div class="section__header">
      <span class="section__title caption-xsmall-caps">{{ section.label }}</span>
      <!-- Header used to hold nothing but the fixed Top Bar; it now accepts the Goals Progress Bar
           too, so the Add menu is driven by whatever can actually go in the section. -->
      @if (availableBySection[section.id].length) {
        <div
          class="section__add"
          pdqPopover
          [popoverTemplate]="addMenu"
          [closeOnPopoverClick]="true"
          forcePosition="bottom_right">
          <pdq-button
            plain="true"
            variant="secondary"
            size="small"
            icon="Plus"
            label="Add"
            iconColor="var(--secondary-default)"
            labelColor="var(--secondary-default)"></pdq-button>
        </div>
      }
    </div>

    <div
      cdkDropList
      [cdkDropListData]="blocksBySection[section.id]"
      (cdkDropListDropped)="onDrop(section.id, $event)"
      class="section__list">
      @for (block of blocksBySection[section.id]; track block.id) {
        <div cdkDrag [cdkDragDisabled]="!blockDefinitions[block.type].draggable" class="block-card">
          <pdq-card variant="popover" color="white">
            <div class="block-card__row">
              <div class="block-card__title">
                @if (blockDefinitions[block.type].draggable) {
                  <pdq-drag-and-drop cdkDragHandle></pdq-drag-and-drop>
                }
                <div class="block-card__heading">
                  <pdq-heading element="h6">{{ blockDefinitions[block.type].label }}</pdq-heading>
                  @if (changedByBlockId[block.id]) {
                    <span class="block-card__changes">Changes made</span>
                  }
                  @if (settingsByBlockId[block.id]?.errors?.['autoAppliedOrderDiscountWithDisplayConditions']) {
                    <span class="block-card__error">Auto-applied order discount can't use display conditions</span>
                  }
                </div>
              </div>
              <div class="block-card__actions">
                @if (blockDefinitions[block.type].toggleable) {
                  <pdq-slide-toggle
                    [defaultValue]="block.enabled"
                    (onToggle)="onToggleEnabled(block, $event)"></pdq-slide-toggle>
                }
                @if (blockDefinitions[block.type].removable) {
                  <pdq-button
                    icon="trash"
                    variant="ghost"
                    plain="true"
                    size="medium"
                    iconColor="var(--on-surface-light)"
                    (onClick)="onRemoveBlock(section.id, block)"></pdq-button>
                }
                <pdq-button
                  icon="edit-1"
                  variant="ghost"
                  plain="true"
                  size="medium"
                  iconColor="var(--on-surface-light)"
                  (onClick)="onEditBlock(block)"></pdq-button>
              </div>
            </div>
          </pdq-card>
        </div>
      }
    </div>

    <ng-template #addMenu>
      <pdq-popover-container [loading]="false">
        <div class="add-menu">
          @for (option of availableBySection[section.id]; track option.type) {
            <pdq-button
              class="add-menu__item"
              [class.add-menu__item--disabled]="option.disabled"
              variant="empty"
              fullWidth="true"
              [disabled]="option.disabled"
              (onClick)="onAddBlock(section.id, option.type)">
              <span class="add-menu__content">
                <span class="add-menu__label">{{ option.label }}</span>
                @if (option.disabled) {
                  <span class="add-menu__hint">Already in your cart</span>
                }
              </span>
            </pdq-button>
          }
        </div>
      </pdq-popover-container>
    </ng-template>
  </div>
}
